module.exports = __webpack_public_path__ + "img/error.8a57cb52.svg";